/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileSpreadsheet16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M14 12.49c0 .282-.229.51-.5.51h-11a.505.505 0 01-.5-.51V3.51c0-.282.229-.51.5-.51h11c.276 0 .5.228.5.51v8.98zM3 12h2v-2H3v2zm10-2H6v2h7v-2zm0-1V7H6v2h7zM3 9h2V7H3v2zm10-3V4H6v2h7zM5 4H3v2h2V4z"
        />
    </AccessibleSVG>
);

export default FileSpreadsheet16;
